import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Slide {
  id: number;
  label: string;
}

@Component({
  selector: 'app-pont-rx-demo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pontrx-demo.component.html',
  styleUrls: ['./pontrx-demo.component.scss']
})
export class PontRxDemoComponent implements OnInit, OnDestroy {

  current = 0;

  slides: Slide[] = [
    { id: 1,  label: 'Title' },
    { id: 2,  label: 'Agenda' },
    { id: 3,  label: 'Part 1 — The Problem' },
    { id: 4,  label: 'The Problem' },
    { id: 5,  label: 'Part 2 — The Platform' },
    { id: 6,  label: 'Platform Architecture Diagram' },
    { id: 7,  label: 'My Role' },
    { id: 8,  label: 'Part 3 — EHR Integration' },
    { id: 9,  label: 'EHR Comparison Table' },
    { id: 10, label: 'Normalization Layer Diagram' },
    { id: 11, label: 'Part 4 — FHIR Auth' },
    { id: 12, label: 'FHIR Auth Flow Diagram' },
    { id: 13, label: 'FHIR Auth — Real Code' },
    { id: 14, label: 'Bulk Data Flow Diagram' },
    { id: 15, label: 'Part 5 — Reliability' },
    { id: 16, label: 'EventBridge Pipeline Diagram' },
    { id: 17, label: 'EventBridge — Real Code' },
    { id: 18, label: 'SMS Intake' },
    { id: 19, label: 'Part 6 — Lessons' },
    { id: 20, label: 'Lessons Learned' },
    { id: 21, label: 'Impact Numbers' },
    { id: 22, label: 'Why Zus Health' },
  ];

  get total(): number { return this.slides.length; }
  get progress(): number { return ((this.current + 1) / this.total) * 100; }
  get currentLabel(): string { return this.slides[this.current]?.label ?? ''; }

  ngOnInit(): void {}
  ngOnDestroy(): void {}

  goTo(index: number): void {
    if (index < 0 || index >= this.total) return;
    this.current = index;
  }

  next(): void { this.goTo(this.current + 1); }
  prev(): void { this.goTo(this.current - 1); }

  @HostListener('document:keydown', ['$event'])
  onKey(e: KeyboardEvent): void {
    if (e.key === 'ArrowRight' || e.key === ' ') { e.preventDefault(); this.next(); }
    if (e.key === 'ArrowLeft')                   { e.preventDefault(); this.prev(); }
    if (e.key === 'Home')                        { e.preventDefault(); this.goTo(0); }
    if (e.key === 'End')                         { e.preventDefault(); this.goTo(this.total - 1); }
  }
}
